import DashboardIcon from "@material-ui/icons/Dashboard";
import FilterListIcon from "@material-ui/icons/FilterList";

import Assinatura from "views/Assinatura/Assinatura.jsx";
import BuscaCativo from "views/Dashboard/BuscaCativo.jsx";
import Dashboard from "views/Dashboard/Dashboard.jsx";
import Relatorio from "views/Dashboard/Relatorio.jsx";
import SimuladorCativo from "views/Pages/SimuladoresPage.jsx";
import UserProfile from "views/User/UserProfile.jsx";

const dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    component: Dashboard,
  },
  {
    path: "/dashboard/relatorios",
    name: "Relatórios",
    icon: FilterListIcon,
    component: Relatorio,
  },
  {
    path: "/dashboard/busca-cativo",
    name: "Busca Cativo",
    icon: FilterListIcon,
    component: BuscaCativo,
  },
  {
    path: "/dashboard/simulador-cativo-livre",
    name: "Simulador Cativo",
    icon: DashboardIcon,
    component: SimuladorCativo,
  },
];

const internalRoutes = [
  {
    path: "/dashboard/perfil",
    name: "Meu Perfil",
    mini: "MP",
    component: UserProfile,
  },
  {
    path: "/dashboard/assinatura",
    name: "Assinatura",
    mini: "AS",
    component: Assinatura,
  },
];

export { internalRoutes };
export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx